import { cn } from "@/shared/lib/utils";

export interface AccessHeaderStatProps {
  label: string;
  /**
   * A count, or a placeholder such as `"—"` when the number is genuinely UNKNOWN (the counts request failed).
   * Rendering `0` in that case would read as an authoritative "none", which on an access screen is the
   * opposite of the truth.
   */
  value: number | string;
  /** Render the value in the destructive tone (e.g. "Sin roles", "Deny activos"). */
  danger?: boolean;
}

/** Compact right-aligned stat for the access section headers (label + number). */
export function AccessHeaderStat({ label, value, danger }: AccessHeaderStatProps) {
  return (
    <div className="text-right">
      <div className="font-mono text-[9.5px] uppercase tracking-[0.06em] text-muted-foreground">{label}</div>
      <div
        className={cn(
          "font-mono text-[16px] font-semibold tabular-nums",
          danger ? "text-destructive" : "text-foreground",
        )}
      >
        {value}
      </div>
    </div>
  );
}
